// extracted by mini-css-extract-plugin
export default {"text":"BackTextButton_text__8jv0M","backIcon":"BackTextButton_backIcon__fSKzF","wrapper":"BackTextButton_wrapper__27445"};